/**
 * 361 Sleep — shared scroll reveal
 * Sections opt in with data-reveal-scope. Inside, elements marked
 * data-reveal fade/rise when they become visible; a data-reveal-group
 * container reveals its children together with a stagger.
 * data-reveal="scale" fades with a soft zoom instead of the rise.
 *
 * Visibility is detected with IntersectionObserver (not ScrollTrigger
 * positions) so pinned/scrubbed sections elsewhere on the page can never
 * leave content stuck hidden.
 */
(function () {
  'use strict';

  if (window.__reveal361) return;
  window.__reveal361 = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function whenGsap(fn) {
    if (window.gsap) {
      fn(window.gsap);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.gsap) {
        clearInterval(timer);
        fn(window.gsap);
      } else if (tries > 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function hiddenVars(el) {
    if (el.getAttribute('data-reveal') === 'scale') {
      return { opacity: 0, scale: 0.965, transformOrigin: 'center center' };
    }
    return { opacity: 0, y: 30 };
  }

  function reveal(gsap, targets, stagger) {
    gsap.to(targets, {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: 0.75,
      ease: 'power2.out',
      stagger: stagger || 0,
      overwrite: 'auto',
      onComplete: function () {
        gsap.set(targets, { clearProps: 'opacity,transform' });
      }
    });
  }

  function initAll(gsap) {
    if (REDUCED.matches || !('IntersectionObserver' in window)) return;

    var actions = new Map();

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          var play = actions.get(entry.target);
          if (play) {
            actions.delete(entry.target);
            play();
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );

    function watch(trigger, play) {
      actions.set(trigger, play);
      io.observe(trigger);
    }

    document.querySelectorAll('[data-reveal-scope]').forEach(function (section) {
      if (section.hasAttribute('data-reveal-ready')) return;
      section.setAttribute('data-reveal-ready', '');

      var groups = Array.prototype.slice.call(section.querySelectorAll('[data-reveal-group]'));
      var all = Array.prototype.slice.call(section.querySelectorAll('[data-reveal]'));
      var singles = all.filter(function (el) {
        return !groups.some(function (g) {
          return g.contains(el);
        });
      });

      singles.forEach(function (el) {
        gsap.set(el, hiddenVars(el));
        watch(el, function () {
          reveal(gsap, el, 0);
        });
      });

      groups.forEach(function (group) {
        var children = Array.prototype.slice.call(group.querySelectorAll('[data-reveal]'));
        if (!children.length) return;
        children.forEach(function (child) {
          gsap.set(child, hiddenVars(child));
        });
        watch(group, function () {
          reveal(gsap, children, 0.12);
        });
      });
    });
  }

  function boot() {
    whenGsap(initAll);
  }

  ready(boot);

  document.addEventListener('shopify:section:load', boot);
})();
